/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2020, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

const APITypes = {
  graphql: 'GraphQL',
  wsdl: 'SOAP',
  rest: 'REST',
  asyncapi: 'AsyncAPI'
};

function getAPIType(api) {
  if (api.asyncapi) {
    return APITypes.asyncapi;
  }
  const type = api['x-ibm-configuration'] && api['x-ibm-configuration'].type;
  if (type) {
    if (APITypes[type]) {
      return APITypes[type];
    }
    return type;
  }
  return APITypes.rest;
}

export { APITypes, getAPIType };
